/** @type {import('@vue/compat').ComponentOptions} */
export default {
  data: {
    data: '',
    selector: '.favorite-page .qk-grid',
    api: 'getUserFavoritesList',
    param: {
      user_id: qk_author.author_id,
      size: 10,
      post_type: 'post',
    },
    tabs: ['post', 'shop', 'video'],
    isDataEmpty: false,
    loading: true,
    locked: false,
  },
  mounted() {
    Tabs();

    window.addEventListener('tabChange', (event) => {
      this.param.post_type = this.tabs[event.detail.index];
      this.data = '';
      this.loading = true;
      this.isDataEmpty = false;
      this.loadData();
    });

    this.loadData();
  },
  methods: {
    loadData() {
      this.$nextTick(() => {
        this.$refs.postsPageNav.load(1, '', true);
      });
    },
    change(data) {
      this.data = data.data;
      this.isDataEmpty = this.data === '';
      this.loading = !this.loading;
    },
  },
};
